<div
  class="view--base view--direction-{{ direction }} view--justify-{{
    justify
  }} view--align-{{ align }} view--spacing-bottom-{{
    spacingBottom
  }} view--spacing-top-{{ spacingTop }} view--column-gap-{{
    columnGap
  }} view--row-gap-{{ rowGap }} view--gap-{{ gap }}"
  [style.padding]="padding"
>
  <ng-content></ng-content>
</div>
